export default __webpack_public_path__ + "static/media/level-6-bg.aefe15f6.png";